export const API_PATH_ApiTrafficStudyPostsLoadGet = '/services/traffic-studies/apiTrafficStudyPostsLoadGet';
